import React from 'react';
import { motion } from 'framer-motion';
interface FloatingShapesProps {
  className?: string;
}
/**
 * Soft, blurred floating gold decorations used behind hero / feature sections.
 * Purely decorative — hidden from assistive tech.
 */
export function FloatingShapes({
  className = ''
}: FloatingShapesProps) {
  const shapes = [{
    size: 260,
    top: '-6%',
    left: '-4%',
    delay: 0,
    dur: 11,
    opacity: 0.14
  }, {
    size: 170,
    top: '18%',
    right: '6%',
    delay: 1.5,
    dur: 9,
    opacity: 0.1
  }, {
    size: 120,
    bottom: '8%',
    left: '12%',
    delay: 0.8,
    dur: 13,
    opacity: 0.12
  }, {
    size: 90,
    bottom: '24%',
    right: '18%',
    delay: 2.2,
    dur: 10,
    opacity: 0.16
  }];
  return <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} data-id="element-241">
      {shapes.map((s, i) => <motion.span key={i} className="absolute rounded-full bg-gold blur-3xl" style={{
      width: s.size,
      height: s.size,
      top: s.top,
      left: s.left,
      right: s.right,
      bottom: s.bottom,
      opacity: s.opacity
    }} animate={{
      y: [0, -28, 0],
      x: [0, 14, 0]
    }} transition={{
      duration: s.dur,
      delay: s.delay,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-242" />)}
    </div>;
}